module.exports = __webpack_public_path__ + "static/media/preview_chart_1_Leads.928ee3c3.PNG";